<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2024-06-06 14:34:22
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-06-12 14:54:15
 * @FilePath: /partner.chaoyongtuan.com/src/views/settings/message/tableCells/cooSwitchCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-popover placement="bottom-end" width="384" :value="visiblePopover && visiblePopoverType == row.sub_type" trigger="manual">
		<p class="mb-10">
			<i class="el-icon-warning color-o-4" />
			{{ row.status == 1 ? '开启后，满足条件时将推送消息，确定要开启吗？' : '关闭后将不会推送此类型的消息，确定要关闭吗' }}
		</p>
		<div style="text-align: right; margin: 0">
			<el-button class="mr-10" size="mini" type="text" @click="visiblePopover = false">取消</el-button>
			<el-button type="primary" size="mini" @click="handleOnOff(row)">确定</el-button>
		</div>
		<template slot="reference">
			<el-switch @change="handleStatusChange(row)" :value="row.status" :active-value="2" :inactive-value="1" />
		</template>
	</el-popover>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
import { messageOnOff } from '@/api/settings';

export default {
	mixins: [mixin],
	data() {
		return {
			visiblePopover: false,
			visiblePopoverType: '',
		};
	},
	inject: {
		injectGetList: {
			default: () => {},
		},
	},
	methods: {
		handleStatusChange(row) {
			this.visiblePopoverType = row.sub_type;
			this.visiblePopover = true;
		},
		async handleOnOff(item) {
			await messageOnOff({
				status: item.status == 1 ? 2 : 1,
				id: item.id,
			});
			this.visiblePopover = false;
			this.injectGetList();
		},
	},
};
</script>